import { h, Component } from 'preact';

import './index.less';

import { getVideoBanner, getVideoYoutubeId } from '../../lib/GroupAmalgam';
import { getYoutubeIframeReady, setYoutubeIframeReady } from '../../lib/GroupUtils';
import { getPrimaryLoaderStyle } from '../../lib/Utils';

class Banner extends Component {
  state = {
    loadingPlayer: false,
    hideBanner: false
  };

  playerSize = {};
  player = null;

  onBannerClick = () => {
    if (!window.postMessage) {
      // Youtube player is not supported
      window.location.href = `https://www.youtube.com/watch?v=${getVideoYoutubeId()}`;
      return;
    }

    if (!this.playerContainer) {
      return;
    }

    this.setState({ loadingPlayer: true });

    const { height, width } = this.playerContainer.getBoundingClientRect();
    this.playerSize = { height, width };

    window.onYouTubeIframeAPIReady = this.onYouTubeIframeReady;

    if (getYoutubeIframeReady()) {
      this.onYouTubeIframeReady();
    } else {
      const tag = document.createElement('script');
      tag.type = 'text/javascript';
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      if (
        firstScriptTag &&
        firstScriptTag.parentNode &&
        typeof firstScriptTag.parentNode.insertBefore === 'function'
      ) {
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    }
  };

  onYouTubeIframeReady = () => {
    setYoutubeIframeReady();

    this.setState({ hideBanner: true });

    this.player = new window.YT.Player('player', {
      height: this.playerSize.height,
      width: this.playerSize.width,
      videoId: getVideoYoutubeId(),
      events: {
        onReady: this.onPlayerReady
      }
    });
  };

  onPlayerReady = (event) => {
    this.setState({ loadingPlayer: false });
    event.target.playVideo();
  };

  render () {
    const { loadingPlayer, hideBanner } = this.state;

    const bannerImage = getVideoBanner();
    const videoYoutubeId = getVideoYoutubeId();

    if (!bannerImage || !videoYoutubeId) {
      return null;
    }

    return (
      <div className="group-banner">
        <div ref={(element) => (this.playerContainer = element)} className="player-container">
          <div id="player">
            {hideBanner ? (
              <div />
            ) : (
              <img
                className="banner-image"
                alt="banner"
                src={bannerImage}
                onClick={this.onBannerClick}
              />
            )}
          </div>

          {loadingPlayer ? (
            <div className="loader-container">
              <div className="loader" style={getPrimaryLoaderStyle()} />
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }
}

export default Banner;
